module.exports = __webpack_public_path__ + "static/media/Decorate.acc59112.mp3";